
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { AgGridModule } from "ag-grid-angular";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { AnbudKontraktListComponent } from "./anbud-kontrakt/anbud-kontrakt-list/anbud-kontrakt-list.component";
import { AnbudKontraktComponent } from "./anbud-kontrakt/anbud-kontrakt.component";
import { KontraktSaveFilterComponent } from "./anbud-kontrakt/sok-anbud-kontrakt/kontrakt-search-mina-filter/kontrakt-save-filter/kontrakt-save-filter.component";
import { KontraktSearchMinaFilterComponent } from "./anbud-kontrakt/sok-anbud-kontrakt/kontrakt-search-mina-filter/kontrakt-search-mina-filter.component";
import { SokAnbudKontraktComponent } from "./anbud-kontrakt/sok-anbud-kontrakt/sok-anbud-kontrakt.component";
import { AtgardAvverkningsanmalanComponent } from "./atgarder/atgard-avverkningsanmalan/atgard-avverkningsanmalan.component";
import { AtgardBadgeComponent } from "./atgarder/atgard-badge/atgard-badge.component";
import { AvverkningsgruppForkortningPipe } from "./atgarder/atgard-badge/avverkningsgrupp-forkortning.pipe";
import { AtgardDetaljerComponent } from "./atgarder/atgard-detaljer/atgard-detaljer.component";
import { AddTradslagButtonComponent } from "./atgarder/atgard-forkalkyl/add-tradslag-button/add-tradslag-button.component";
import { AtgardAvverkningskostnadComponent } from "./atgarder/atgard-forkalkyl/atgard-avverkningskostnad/atgard-avverkningskostnad.component";
import { AtgardForkalkylComponent } from "./atgarder/atgard-forkalkyl/atgard-forkalkyl.component";
import { AtgardVirkeskostnadComponent } from "./atgarder/atgard-forkalkyl/atgard-virkeskostnad/atgard-virkeskostnad.component";
import { BeraknatUtbyteButtonComponent } from "./atgarder/atgard-forkalkyl/beraknat-utbyte-button/beraknat-utbyte-button.component";
import { BeraknatUtbyteValidationComponent } from "./atgarder/atgard-forkalkyl/beraknat-utbyte-validation/beraknat-utbyte-validation.component";
import { ForkalkylArborealComponent } from "./atgarder/atgard-forkalkyl/forkalkyl-arboreal/forkalkyl-arboreal.component";
import { ForkalkylDirektutbyteComponent } from "./atgarder/atgard-forkalkyl/forkalkyl-direktutbyte/forkalkyl-direktutbyte.component";
import { ForkalkylNettoberakningComponent } from "./atgarder/atgard-forkalkyl/forkalkyl-nettoberakning/forkalkyl-nettoberakning.component";
import { ForkalkylSnabbkalkylComponent } from "./atgarder/atgard-forkalkyl/forkalkyl-snabbkalkyl/forkalkyl-snabbkalkyl.component";
import { ForkalkylTradslagComponent } from "./atgarder/atgard-forkalkyl/forkalkyl-tradslag/forkalkyl-tradslag.component";
import { TradslagMallComponent } from "./atgarder/atgard-forkalkyl/tradslag-mall/tradslag-mall.component";
import { TradslagUtbyteComponent } from "./atgarder/atgard-forkalkyl/tradslag-utbyte/tradslag-utbyte.component";
import { AtgardHeaderIconComponent } from "./atgarder/atgard-header-icons/atgard-header-icon/atgard-header-icon.component";
import { AtgardHeaderIconsComponent } from "./atgarder/atgard-header-icons/atgard-header-icons.component";
import { AtgardHeaderComponent } from "./atgarder/atgard-header/atgard-header.component";
import { AtgardItemComponent } from "./atgarder/atgard-item/atgard-item.component";
import { AtgardListComponent } from "./atgarder/atgard-list/atgard-list.component";
import { AtgardMbfComponent } from "./atgarder/atgard-mbf/atgard-mbf.component";
import { ForyngringTradslagComponent } from "./atgarder/atgard-mbf/foryngringsatgard/foryngring-tradslag/foryngring-tradslag.component";
import { ForyngringsatgardComponent } from "./atgarder/atgard-mbf/foryngringsatgard/foryngringsatgard.component";
import { MarkberedningsmetodComponent } from "./atgarder/atgard-mbf/markberedningsmetod/markberedningsmetod.component";
import { AtgardNvbComponent } from "./atgarder/atgard-nvb/atgard-nvb.component";
import { NVBMellerstaSverigeComponent } from "./atgarder/atgard-nvb/forms/nvbmellersta-sverige/nvbmellersta-sverige.component";
import { NVBNorraSverigeComponent } from "./atgarder/atgard-nvb/forms/nvbnorra-sverige/nvbnorra-sverige.component";
import { NVBSodraSverigeComponent } from "./atgarder/atgard-nvb/forms/nvbsodra-sverige/nvbsodra-sverige.component";
import { AtgardStatusComponent } from "./atgarder/atgard-status/atgard-status.component";
import { AtgardTransportComponent } from "./atgarder/atgard-transport/atgard-transport.component";
import { AtgardVolymRowComponent } from "./atgarder/atgard-volym/atgard-volym-row/atgard-volym-row.component";
import { AtgardVolymComponent } from "./atgarder/atgard-volym/atgard-volym.component";
import { VardeberakningComponent } from "./atgarder/vardeberakning/vardeberakning.component";
import { LeverantorsinformationComponent } from "./avtal/leverantorsinformation/leverantorsinformation.component";
import { VirkeskopAvtalComponent } from "./avtal/virkeskop-avtal.component";
import { ExternVirkeskopSearchPanelComponent } from "./extern-virkeskop/extern-virkeskop-search/extern-virkeskop-search-panel/extern-virkeskop-search-panel.component";
import { ExternVirkeskopSearchResultComponent } from "./extern-virkeskop/extern-virkeskop-search/extern-virkeskop-search-result/extern-virkeskop-search-result.component";
import { ExternVirkeskopSearchComponent } from "./extern-virkeskop/extern-virkeskop-search/extern-virkeskop-search.component";
import { ForkalkylsmallComponent } from "./forkalkylsmallar/components/forkalkylsmall/forkalkylsmall.component";
import { ForkalkylsmallarDialogService } from "./forkalkylsmallar/components/forkalkylsmallar-dialog.service";
import { SkapaMallFranHandelssortimentComponent } from "./forkalkylsmallar/components/skapa-mall-fran-handelssortiment/skapa-mall-fran-handelssortiment.component";
import { ForkalkylsmallarComponent } from "./forkalkylsmallar/forkalkylsmallar.component";
import { MinaForkalkylsmallarDialogService } from "./forkalkylsmallar/mina-forkalkylsmallar-dialog.service";
import { BusyInterceptor } from "./interceptors/busy.interceptor";
import { SkogsvardMapLayerToggleComponent } from "./karta/skogsvard-map-layer-toggle/skogsvard-map-layer-toggle.component";
import { VkKartaAtgardPopupComponent } from "./karta/vk-karta-atgard-popup/vk-karta-atgard-popup.component";
import { VkKartaCollectorPopupComponent } from "./karta/vk-karta-collector-popup/vk-karta-collector-popup.component";
import { VkKartaFastigheterPopupComponent } from "./karta/vk-karta-fastigheter-popup/vk-karta-fastigheter-popup.component";
import { VkKartaFastigheterComponent } from "./karta/vk-karta-fastigheter/vk-karta-fastigheter.component";
import { VkKartaComponent } from "./karta/vk-karta/vk-karta.component";
import { KontraktDrivningspunkterValidationComponent } from "./kontrakt-drivningspunkter-validation/kontrakt-drivningspunkter-validation.component";
import { KontraktCertifieringComponent } from "./kontrakt/certifiering/kontrakt-certifiering/kontrakt-certifiering.component";
import { KontraktCertifikatComponent } from "./kontrakt/certifiering/kontrakt-certifikat/kontrakt-certifikat.component";
import { KontraktAnteckningarComponent } from "./kontrakt/kontrakt-anteckningar/kontrakt-anteckningar.component";
import { BetalningLeverantorComponent } from "./kontrakt/kontrakt-betalning/betalning-leverantor/betalning-leverantor.component";
import { BetalningSkogsvardCommentComponent } from "./kontrakt/kontrakt-betalning/betalning-skogsvard/betalning-skogsvard-comment/betalning-skogsvard-comment.component";
import { BetalningSkogsvardComponent } from "./kontrakt/kontrakt-betalning/betalning-skogsvard/betalning-skogsvard.component";
import { KontraktBetalningComponent } from "./kontrakt/kontrakt-betalning/kontrakt-betalning.component";
import { KontraktBilagorComponent } from "./kontrakt/kontrakt-bilagor/kontrakt-bilagor.component";
import { KontraktChecklistComponent } from "./kontrakt/kontrakt-checklist/kontrakt-checklist.component";
import { KontraktDokumentComponent } from "./kontrakt/kontrakt-dokument/kontrakt-dokument.component";
import { KontraktForkalkylComponent } from "./kontrakt/kontrakt-forkalkyl/kontrakt-forkalkyl.component";
import { KontraktHeaderIconsComponent } from "./kontrakt/kontrakt-header/kontrakt-header-icons/kontrakt-header-icons.component";
import { KontraktHeaderComponent } from "./kontrakt/kontrakt-header/kontrakt-header.component";
import { VacsStatusComponent } from "./kontrakt/kontrakt-header/vacs-status/vacs-status.component";
import { ViolEditorPopoverComponent } from "./kontrakt/kontrakt-header/viol-editor-popover/viol-editor-popover.component";
import { KontraktItemComponent } from "./kontrakt/kontrakt-item/kontrakt-item.component";
import { KontraktListComponent } from "./kontrakt/kontrakt-list/kontrakt-list.component";
import { KontraktNvbComponent } from "./kontrakt/kontrakt-nvb/kontrakt-nvb.component";
import { KontraktGrupperingComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-gruppering/kontrakt-gruppering.component";
import { KontraktJusteraUtskriftComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-justera-utskrift/kontrakt-justera-utskrift.component";
import { KontraktPrislistaFilterComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-prislista-filter/kontrakt-prislista-filter.component";
import { KontraktPrisradComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-prisrad/kontrakt-prisrad.component";
import { KontraktPristabellComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-pristabell/kontrakt-pristabell.component";
import { KontraktUtskriftComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-utskrift.component";
import { KontraktVolymBeloppComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-volym-belopp/kontrakt-volym-belopp.component";
import { KontraktVacsComponent } from "./kontrakt/kontrakt-vacs/kontrakt-vacs.component";
import { LeveransvirkesplanComponent } from "./kontrakt/leveransvirkesplan/leveransvirkesplan.component";
import { LeverantorerComponent } from "./leverantorer/leverantorer.component";
import { SokLeverantorModalComponent } from "./leverantorer/sok-leverantor-modal/sok-leverantor-modal.component";
import { MarknadsprislistaDialogComponent } from "./marknadsprislista/marknadsprislista-dialog/marknadsprislista-dialog.component";
import { MarknadsprislistaSearchComponent } from "./marknadsprislista/marknadsprislista-search/marknadsprislista-search.component";
import { MarknadsprislistaComponent } from "./marknadsprislista/marknadsprislista.component";
import { MinaHandelssortimentDialogService } from "./mina-handelssortiment/mina-handelssortiment-dialog.service";
import { MinaHandlessortimentListComponent } from "./mina-handelssortiment/mina-handelssortiment-list/mina-handelssortiment-list.component";
import { MinaHandlessortimentResultComponent } from "./mina-handelssortiment/mina-handelssortiment-result/mina-handelssortiment-result.component";
import { MinaHandlessortimentSearchPanelComponent } from "./mina-handelssortiment/mina-handelssortiment-search-panel/mina-handelssortiment-search-panel.component";
import { MinaHandelssortimentComponent } from "./mina-handelssortiment/mina-handelssortiment.component";
import { ForkalkylsmallarService } from "./services/forkalkylsmallar.service";
import { MarknadsprislistaDialogService } from "./services/marknadsprislista-dialog.service";
import { MarknadsprislistaService } from "./services/marknadsprislista.service";
import { MinaHandelssortimentService } from "./services/mina-handelssortiment.service";
import { VirkeskopService } from "./services/virkeskop.service";
import { SkogsvardBadgeComponent } from "./skogsvard/skogsvard-badge/skogsvard-badge.component";
import { SkogsvardCreateDialogComponent } from "./skogsvard/skogsvard-create-dialog/skogsvard-create-dialog.component";
import { SkogsvardCreateRowComponent } from "./skogsvard/skogsvard-create-dialog/skogsvard-create-row/skogsvard-create-row.component";
import { SkogsvardSelectAtgardComponent } from "./skogsvard/skogsvard-create-dialog/skogsvard-select-atgard/skogsvard-select-atgard.component";
import { SkogsvardCreateOchSokDialogComponent } from "./skogsvard/skogsvard-create-och-sok-dialog/skogsvard-create-och-sok-dialog.component";
import {
    SkogsvardDetaljerForTradslagComponent
} from "./skogsvard/skogsvard-detaljer/skogsvard-detaljer-for/skogsvard-detaljer-for-tradslag/skogsvard-detaljer-for-tradslag.component";
import { SkogsvardDetaljerForComponent } from "./skogsvard/skogsvard-detaljer/skogsvard-detaljer-for/skogsvard-detaljer-for.component";
import { SkogsvardDetaljerMbForComponent } from "./skogsvard/skogsvard-detaljer/skogsvard-detaljer-mb/skogsvard-detaljer-mb-for/skogsvard-detaljer-mb-for.component";
import { SkogsvardDetaljerMbComponent } from "./skogsvard/skogsvard-detaljer/skogsvard-detaljer-mb/skogsvard-detaljer-mb.component";
import { SkogsvardDetaljerComponent } from "./skogsvard/skogsvard-detaljer/skogsvard-detaljer.component";
import { SkogsvardForyngringTradslagComponent } from "./skogsvard/skogsvard-foryngring/skogsvard-foryngring-tradslag/skogsvard-foryngring-tradslag.component";
import { SkogsvardForyngringComponent } from "./skogsvard/skogsvard-foryngring/skogsvard-foryngring.component";
import { SkogsvardHeaderComponent } from "./skogsvard/skogsvard-header/skogsvard-header.component";
import { SkogsvardItemComponent } from "./skogsvard/skogsvard-item/skogsvard-item.component";
import { SkogsvardListComponent } from "./skogsvard/skogsvard-list/skogsvard-list.component";
import { SkogsvardMarkbehandlingStandortComponent } from "./skogsvard/skogsvard-markbehandling-standort/skogsvard-markbehandling-standort.component";
import { SkogsvardOvrigtComponent } from "./skogsvard/skogsvard-ovrigt/skogsvard-ovrigt.component";
import { SkogsvardTradslagPlantorRowComponent } from "./skogsvard/skogsvard-tradslag-plantor/skogsvard-tradslag-plantor-row/skogsvard-tradslag-plantor-row.component";
import { SkogsvardTradslagPlantorComponent } from "./skogsvard/skogsvard-tradslag-plantor/skogsvard-tradslag-plantor.component";
import { MaxDateDirective } from "./validation/directives/max-date.directive";
import { MinDateDirective } from "./validation/directives/min-date.directive";
import { VirkeskopValidationRuleDirective } from "./validation/directives/virkeskop-validation-rule.directive";
import { VirkeskopValidationIconPopoverComponent } from "./validation/validation-icon-popover/virkeskop-validation-icon-popover.component";
import { VirkeskopValidationMessageComponent } from "./validation/validation-message/virkeskop-validation-message.component";
import { ViolversionSelectorComponent } from "./violversion-selector/violversion-selector.component";
import { VirkeskopKartaEventService } from "./virkeskop-karta/virkeskop-karta-event.service";
import { VirkesleverantorListComponent } from "./virkesleverantor/components/virkesleverantor-list/virkesleverantor-list.component";
import { LeverantorDialogService } from "./virkesleverantor/dialog/leverantor-dialog.service";
import { LeverantorService } from "./virkesleverantor/dialog/leverantor.service";
import { LeverantorValidation } from "./virkesleverantor/dialog/leverantor.validation";
import { RedigeraLeverantorDialogComponent } from "./virkesleverantor/dialog/redigera-leverantor-dialog/redigera-leverantor-dialog.component";
import { RedigeraAnsvarigVirkeskopareComponent } from "./virkesleverantor/dialog/redigera-leverantor/redigera-ansvarig-virkeskopare/redigera-ansvarig-virkeskopare.component";
import { RedigeraIntressentComponent } from "./virkesleverantor/dialog/redigera-leverantor/redigera-intressent/redigera-intressent.component";
import { VirkesleverantorService } from "./virkesleverantor/services/virkesleverantor.service";
import { VirkesleverantorComponent } from "./virkesleverantor/virkesleverantor.component";

import { AvtalKundComponent } from "../skogsvardfpv/avtal/avtal-kund/avtal-kund.component";
import { SkogsvardFPVAvtalComponent } from "../skogsvardfpv/avtal/rask-skogsvard-fpv-avtal.component";
import { SokFPVAvtalComponent } from "../skogsvardfpv/avtal/sok-avtal/sok-skogsvard-fpv-avtal.component";
import { AtgardAvverkningsanmalanSamradComponent } from "./atgarder/atgard-avverkningsanmalan-samrad/atgard-avverkningsanmalan-samrad.component";
import { AtgardTypDialogComponent } from "./atgarder/atgard-status/atgard-typ-dialog/atgard-typ-dialog.component";
import { ImportGeometriesPopupComponent } from "./karta/import-geometries-popup/import-geometries-popup.component";
import { RitunderlagMapDialogComponent } from "./karta/ritunderlag-map-dialog/ritunderlag-map-dialog.component";
import { VkKartaSkogsvardPopupComponent } from "./karta/vk-karta-skogsvard-popup/vk-karta-skogsvard-popup.component";
import { KontraktChecklistFragaComponent } from "./kontrakt/kontrakt-checklist/kontrakt-checklist-fraga/kontrakt-checklist-fraga.component";
import { KontraktChecklistGruppComponent } from "./kontrakt/kontrakt-checklist/kontrakt-checklist-grupp/kontrakt-checklist-grupp.component";
import { KontraktDigitalsigneringHistorikComponent } from "./kontrakt/kontrakt-digitalsignering/kontrakt-digitalsignering-historik/kontrakt-digitalsignering-historik.component";
import { KontraktDigitalsigneringItemComponent } from "./kontrakt/kontrakt-digitalsignering/kontrakt-digitalsignering-item/kontrakt-digitalsignering-item.component";
import {
    KontraktDigitalsigneringProlongDialogComponent
} from "./kontrakt/kontrakt-digitalsignering/kontrakt-digitalsignering-prolong-dialog/kontrakt-digitalsignering-prolong-dialog.component";
import { KontraktDigitalsigneringComponent } from "./kontrakt/kontrakt-digitalsignering/kontrakt-digitalsignering.component";
import { LeverantorsOrganisationerPopoverComponent } from "./kontrakt/kontrakt-header/leverantors-organisationer-popover/leverantors-organisationer-popover.component";
import { KontraktUtskriftDokumentComponent } from "./kontrakt/kontrakt-utskrift-dokument/kontrakt-utskrift-dokument.component";
import { KontraktAnteckningskogsvardComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-anteckningskogsvard/kontrakt-anteckningskogsvard.component";
import { KontraktGenereraRapportComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-generera-rapport/kontrakt-generera-rapport.component";
import { KontraktMatbeskedComponent } from "./kontrakt/kontrakt-utskrift/kontrakt-matbesked/kontrakt-matbesked.component";
import { SkogsvardDetaljerRojningComponent } from "./skogsvard/skogsvard-detaljer/skogsvard-detaljer-rojning/skogsvard-detaljer-rojning.component";
import { SkogsvardTradskiktTradslagComponent } from "./skogsvard/skogsvard-tradskikt/skogsvard-tradskikt/skogsvard-tradskikt-tradslag/skogsvard-tradskikt-tradslag.component";
import { SkogsvardTradskiktComponent } from "./skogsvard/skogsvard-tradskikt/skogsvard-tradskikt/skogsvard-tradskikt.component";
import { BetalningsinformationComponent } from "./virkesleverantor/dialog/redigera-leverantor-dialog/betalningsinformation/betalningsinformation.component";
import { ExternaOrganisationerComponent } from "./virkesleverantor/dialog/redigera-leverantor-dialog/externa-organisationer/externa-organisationer.component";

@NgModule({
    imports: [
        RaskCommonModule,
        MapModule,
        NgSelectModule,
        AgGridModule,
        KontraktMatbeskedComponent,
        AvtalKundComponent,
        ImportGeometriesPopupComponent,
        KontraktChecklistFragaComponent,
        VirkeskopValidationIconPopoverComponent,
        BetalningsinformationComponent,
        ForkalkylsmallarComponent,
        ForkalkylsmallComponent,
        SkapaMallFranHandelssortimentComponent,
        MarknadsprislistaComponent,
        MarknadsprislistaDialogComponent,
        MinaHandelssortimentComponent,
        MinaHandlessortimentListComponent,
        MinaHandlessortimentResultComponent,
        MinaHandlessortimentSearchPanelComponent,
        VirkesleverantorComponent,
        VirkesleverantorListComponent,
        RedigeraIntressentComponent,
        RedigeraLeverantorDialogComponent,
        RedigeraAnsvarigVirkeskopareComponent,
        SokAnbudKontraktComponent,
        AnbudKontraktListComponent,
        AnbudKontraktComponent,
        KontraktDrivningspunkterValidationComponent,
        MarknadsprislistaSearchComponent,
        ViolversionSelectorComponent,
        LeverantorsinformationComponent,
        KontraktSearchMinaFilterComponent,
        KontraktSaveFilterComponent,
        AddTradslagButtonComponent,
        TradslagUtbyteComponent,
        TradslagMallComponent,
        AtgardVolymRowComponent,
        AtgardVolymComponent,
        KontraktBilagorComponent,
        VirkeskopAvtalComponent,
        KontraktListComponent,
        KontraktItemComponent,
        AtgardListComponent,
        SkogsvardListComponent,
        SkogsvardItemComponent,
        SkogsvardCreateOchSokDialogComponent,
        SkogsvardCreateDialogComponent,
        SkogsvardCreateRowComponent,
        AtgardDetaljerComponent,
        SokLeverantorModalComponent,
        LeverantorerComponent,
        KontraktCertifieringComponent,
        KontraktAnteckningarComponent,
        KontraktCertifikatComponent,
        KontraktChecklistComponent,
        KontraktHeaderComponent,
        AtgardItemComponent,
        LeveransvirkesplanComponent,
        AtgardHeaderComponent,
        AtgardStatusComponent,
        AtgardHeaderIconsComponent,
        AtgardAvverkningsanmalanComponent,
        AtgardNvbComponent,
        NVBMellerstaSverigeComponent,
        NVBNorraSverigeComponent,
        NVBSodraSverigeComponent,
        AvverkningsgruppForkortningPipe,
        AvverkningsgruppForkortningPipe,
        VirkeskopValidationMessageComponent,
        VirkeskopValidationRuleDirective,
        VkKartaComponent,
        VkKartaAtgardPopupComponent,
        VkKartaCollectorPopupComponent,
        VkKartaFastigheterComponent,
        VkKartaFastigheterPopupComponent,
        AtgardMbfComponent,
        MarkberedningsmetodComponent,
        ForyngringsatgardComponent,
        ForyngringTradslagComponent,
        AtgardForkalkylComponent,
        ForkalkylTradslagComponent,
        ForkalkylSnabbkalkylComponent,
        ForkalkylDirektutbyteComponent,
        AtgardBadgeComponent,
        AtgardTransportComponent,
        KontraktUtskriftComponent,
        ForkalkylNettoberakningComponent,
        KontraktBetalningComponent,
        BetalningLeverantorComponent,
        MinDateDirective,
        AtgardVirkeskostnadComponent,
        KontraktJusteraUtskriftComponent,
        KontraktPristabellComponent,
        BeraknatUtbyteButtonComponent,
        BeraknatUtbyteValidationComponent,
        KontraktPrisradComponent,
        KontraktForkalkylComponent,
        AtgardAvverkningskostnadComponent,
        KontraktPrislistaFilterComponent,
        VardeberakningComponent,
        KontraktGrupperingComponent,
        KontraktVolymBeloppComponent,
        ViolEditorPopoverComponent,
        KontraktVacsComponent,
        AtgardHeaderIconComponent,
        KontraktNvbComponent,
        ForkalkylArborealComponent,
        KontraktHeaderIconsComponent,
        VacsStatusComponent,
        SkogsvardForyngringComponent,
        SkogsvardForyngringTradslagComponent,
        SkogsvardMarkbehandlingStandortComponent,
        SkogsvardOvrigtComponent,
        SkogsvardDetaljerComponent,
        SkogsvardDetaljerMbComponent,
        SkogsvardDetaljerMbForComponent,
        SkogsvardDetaljerForComponent,
        SkogsvardDetaljerForTradslagComponent,
        SkogsvardOvrigtComponent,
        SkogsvardTradslagPlantorComponent,
        SkogsvardTradslagPlantorRowComponent,
        SkogsvardBadgeComponent,
        SkogsvardHeaderComponent,
        SkogsvardTradslagPlantorRowComponent,
        SkogsvardSelectAtgardComponent,
        ExternVirkeskopSearchComponent,
        ExternVirkeskopSearchPanelComponent,
        ExternVirkeskopSearchResultComponent,
        MaxDateDirective,
        KontraktDokumentComponent,
        BetalningSkogsvardComponent,
        BetalningSkogsvardCommentComponent,
        SkogsvardMapLayerToggleComponent,
        KontraktGenereraRapportComponent,
        SkogsvardDetaljerRojningComponent,
        VkKartaSkogsvardPopupComponent,
        ExternaOrganisationerComponent,
        LeverantorsOrganisationerPopoverComponent,
        AtgardTypDialogComponent,
        SkogsvardTradskiktComponent,
        SkogsvardTradskiktTradslagComponent,
        KontraktAnteckningskogsvardComponent,
        SkogsvardFPVAvtalComponent,
        SokFPVAvtalComponent,
        AtgardAvverkningsanmalanSamradComponent,
        RitunderlagMapDialogComponent,
        KontraktDigitalsigneringComponent,
        KontraktUtskriftDokumentComponent,
        KontraktDigitalsigneringItemComponent,
        KontraktDigitalsigneringHistorikComponent,
        KontraktDigitalsigneringProlongDialogComponent,
        KontraktChecklistGruppComponent
    ],
    exports: [
        LeverantorsinformationComponent,
        AddTradslagButtonComponent,
        TradslagUtbyteComponent,
        TradslagMallComponent,
        SkapaMallFranHandelssortimentComponent,
        ViolversionSelectorComponent,
        AvtalKundComponent,
        ImportGeometriesPopupComponent,
        VirkeskopValidationIconPopoverComponent,
        BetalningsinformationComponent
    ],
    providers: [
        ForkalkylsmallarDialogService,
        VirkeskopService,
        ForkalkylsmallarService,
        FormBinderService,
        MarknadsprislistaService,
        MarknadsprislistaDialogService,
        MinaHandelssortimentService,
        NgbActiveModal,
        VirkesleverantorService,
        LeverantorDialogService,
        LeverantorService,
        LeverantorValidation,
        MinaForkalkylsmallarDialogService,
        MinaHandelssortimentDialogService,
        VirkeskopKartaEventService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: BusyInterceptor,
            multi: true
        }
    ]
})
export class VirkeskopngxModule { }
